/**
 * If a catalog product gets an updated id, this interceptor will handle replacing
 * the old id with the new id in old VPC codes
 */
export default class UpdatedIdInterceptor {
    constructor() {
        this.updatedIds = [
            { old: 'door_pivot', new: 'door-pivot-point' }, // Door pivot point
            { old: '10529374', new: '30439589' }, // PLATSA SKYDRAG light strip
            { old: '60529376', new: '10439590' }, // PLATSA SKYDRAG light strip
            { old: '40497828_L', new: '40497828--left' }, // PLATSA HJÄLPA cloth rail
            { old: '40497828_R', new: '40497828--right' }, // PLATSA HJÄLPA cloth rail
            { old: '39428280_60', new: '39428280--60' }, // PLATSA HJÄLPA cloth rail asm
            { old: '39428280_80', new: '39428280--80' }, // PLATSA HJÄLPA cloth rail asm
            { old: '19428295_60', new: '19428295--60' }, // PLATSA HJÄLPA cloth rail w hooks asm
            { old: '19428295_80', new: '19428295--80' }, // PLATSA HJÄLPA cloth rail w hooks asm,
            { old: '10331194_L', new: '10331194--left' }, // PLATSA HJÄLPA pull-out rail for basket 55cm,
            { old: '10331194_R', new: '10331194--right' }, // PLATSA HJÄLPA pull-out rail for basket 55cm,
            { old: '30331193_L', new: '30331193--left' }, // PLATSA HJÄLPA pull-out rail for basket 40cm,
            { old: '30331193_R', new: '30331193--right' }, // PLATSA HJÄLPA pull-out rail for basket 40cm,
            { old: '10509352_lower', new: '1050935--lower' }, // PLATSA LARKOLLEN sliging door rail
            { old: '10509352_upper', new: '10509352--upper' }, // PLATSA LARKOLLEN sliging door rail
            { old: '40518920_lower', new: '40518920--lower' }, // PLATSA LARKOLLEN sliging door rail
            { old: '40518920_upper', new: '40518920--upper' }, // PLATSA LARKOLLEN sliging door rail
            { old: '20525691_40', new: '20525691--40' }, // PLATSA LARKOLLEN sliging door handle
            { old: '20525691_60', new: '20525691--60' }, // PLATSA LARKOLLEN sliging door handle
            { old: '80518923_120', new: '80518923--120' }, // PLATSA LARKOLLEN sliging door handle
            { old: '80518923_180', new: '80518923--180' }, // PLATSA LARKOLLEN sliging door handle
            { old: '10518926_grey_40', new: '10518926--grey_40' }, // PLATSA LARKOLLEN sliding door
            { old: '10518926_grey_60', new: '10518926--grey_60' }, // PLATSA LARKOLLEN sliging door
            { old: '10518926_grey_120', new: '10518926--grey_120' }, // PLATSA LARKOLLEN sliging door
            { old: '10518926_grey_180', new: '10518926--grey_180' }, // PLATSA LARKOLLEN sliging door
            { old: '50518929_grey_40', new: '50518929--grey_40' }, // PLATSA LARKOLLEN sliging door
            { old: '50518929_grey_60', new: '50518929--grey_60' }, // PLATSA LARKOLLEN sliging door
            { old: '50518929_grey_120', new: '50518929--grey_120' }, // PLATSA LARKOLLEN sliging door
            { old: '50518929_grey_180', new: '50518929--grey_180' } // PLATSA LARKOLLEN sliging door
        ];
    }
    beforeDeserialize(json) {
        this.updatedIds.forEach(id => (json = json.replaceAll(id.old, id.new)));
        return json;
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=UpdatedIdInterceptor.js.map